import { Instance, types } from "mobx-state-tree";
import { SubscriptionPlanResponse } from "../../api-models/response/SubscriptionPlanResponse";

import { endpoints } from "../api/ApiEndpoints";
import { StorageModel } from "../storage/StorageModel";
import { SubscriptionPlan } from "./SubscriptionPlan";

const ActiveSubscriptionPlanModel = types.model({
  activeSubscription: types.optional(types.frozen<SubscriptionPlan>(), new SubscriptionPlan()),
});

export const ActiveSubscriptionPlanStorageModel = types
  .compose(ActiveSubscriptionPlanModel, StorageModel)
  .named("ActiveSubscriptionPlanStorageModel")
  .actions((self) => {
    return {
      mapResponse(response: SubscriptionPlanResponse) {
        self.activeSubscription = new SubscriptionPlan(
          response.sewerInspectionPackage,
          response.sewerInspectionModule,
          response.extraStoragePackage,
          response.extraVACallsPackage,
          response.isPaidSubscription
        );
      },
    };
  })
  .views((self) => ({
    get endpoint() {
      return endpoints.get("active_subscription_plan");
    },
    get isLoading() {
      return !self.activeSubscription.id;
    },
    get hasFreeSubscription() {
      return !self.activeSubscription.isPaidSubscription;
    },
  }));

export type ActiveSubscriptionPlanStorage = Instance<typeof ActiveSubscriptionPlanStorageModel>;
